import { createInertiaApp, router } from '@inertiajs/react'
import { createElement } from 'react'
import { hydrateRoot, createRoot } from 'react-dom/client'
import { resolvePage } from '../lib/pages'

// PostHog SPA pageviews. posthog.init runs with capture_pageview:false (see
// app/views/layouts/application.html.erb), so we fire $pageview on every Inertia
// navigation. Inertia's 'navigate' event also fires on the initial page load
// (via fireInitialEvents), giving exactly one pageview per page. Registered
// before createInertiaApp so the initial event isn't missed; posthog reads the
// (already-updated) window.location at capture time. The snippet stub queues
// calls until array.js loads, so early calls are safe.
declare global {
  interface Window {
    posthog?: { capture: (event: string, properties?: Record<string, unknown>) => void }
  }
}
router.on('navigate', () => {
  window.posthog?.capture('$pageview')
})

createInertiaApp({
  resolve: resolvePage,
  setup({ el, App, props }) {
    const app = createElement(App, props)
    // SSR sends server-rendered markup → hydrate it; otherwise mount fresh.
    if (el.hasChildNodes()) hydrateRoot(el, app)
    else createRoot(el).render(app)
  },
  progress: { color: '#fafaf9', showSpinner: false },
})
